'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var sizes = require('../../../constants/sizes.js');
var Rate_module = require('../styles/Rate.module.less.js');
var Star = require('./Star.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const fractionalIndex = (event) => {
    const x = event.clientX - event.currentTarget.getBoundingClientRect().left;
    const offset = x / event.currentTarget.offsetWidth;
    if (offset <= 0.3) {
        return 0.3;
    }
    if (offset > 0.3 && offset <= 0.5) {
        return 0.5;
    }
    if (offset > 0.5 && offset <= 0.8) {
        return 0.8;
    }
    return 1;
};
/**
 * @description A quick rating operation on something
 *
 * @component
 * @example
 * ```jsx
 * <Rate fractional defaultValue={4} count={5} size={36}>
 * ```
 */
const Rate = React__namespace.forwardRef((props, ref) => {
    const { fractional, count, defaultValue, value, size, disabled, onChange, className, ...restProps } = props;
    const cx = reactUtils.useStyles(Rate_module.default);
    const id = reactUtils.useId('rate');
    const classNames = cx(className, 'container', {
        [`size-${size}`]: size,
        disabled,
    });
    const [innerValue, setInnerValue] = React__namespace.useState(defaultValue || value || 0);
    const [hoverIndex, setHoverIndex] = React__namespace.useState(null);
    const handleHover = React__namespace.useCallback((event, index) => {
        const value = fractional ? index + fractionalIndex(event) : index + 1;
        setHoverIndex(value);
    }, [fractional]);
    const handleMouseLeave = React__namespace.useCallback(() => {
        setHoverIndex(null);
    }, []);
    const handleClickRate = React__namespace.useCallback((event, index) => {
        const value = fractional ? index + fractionalIndex(event) : index + 1;
        setInnerValue(value);
        onChange?.(value);
    }, [fractional, onChange]);
    const stars = React__namespace.useMemo(() => Array.from(new Array(count)).map((_, index) => (React__namespace.createElement(Star.Star
    // eslint-disable-next-line react/no-array-index-key
    , { 
        // eslint-disable-next-line react/no-array-index-key
        key: `${id}-${index}`, index: index, value: hoverIndex === null ? innerValue : hoverIndex, fractional: fractional, disabled: disabled, size: size, onHover: handleHover, onClick: handleClickRate }))), [id, hoverIndex, innerValue, count, disabled, fractional, size, handleClickRate, handleHover]);
    React__namespace.useEffect(() => {
        value && setInnerValue(value);
    }, [value]);
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "Rate", className: classNames, ...restProps, onMouseLeave: disabled ? reactUtils.noop : handleMouseLeave }, stars));
});
Rate.defaultProps = {
    fractional: false,
    count: 5,
    size: sizes.STAR_SIZES.S20,
};
Rate.displayName = 'Rate';

exports.Rate = Rate;
//# sourceMappingURL=Rate.js.map
